import React, { useState, useEffect } from 'react';
import PopupBase from './PopupBase';
import SlotApi from '../api/SlotApi';

const SlotExtendPop = ({ isOpen, close, save, data }) => {
    const [extendDays, setExtendDays] = useState(1);
    
    const extendOptions = [
        { key: 1, value: 1, text: '1일' },
        { key: 2, value: 2, text: '2일' },
        { key: 3, value: 3, text: '3일' },
        { key: 4, value: 4, text: '4일' },
        { key: 5, value: 5, text: '5일' },
        { key: 6, value: 6, text: '6일' },
        { key: 7, value: 7, text: '7일' },
        { key: 8, value: 8, text: '8일' },
        { key: 9, value: 9, text: '9일' },
        { key: 10, value: 10, text: '10일' }
    ];

    const handleExtendDaysChange = (e) => {
        setExtendDays(parseInt(e.target.value));
    };

    const handleConfirm = async () => {
        try {
            const result = await SlotApi.extendSlot({
                ids: data.editTargets.map(target => target.ID),
                extendDays: extendDays
            });
            
            if (result.code === 'success') {
                save();
            } else {
                alert('연장에 실패했습니다.');
            }
        } catch (error) {
            console.error('연장 중 오류 발생:', error);
            alert('연장 중 오류가 발생했습니다.');
        }
    };

    useEffect(() => {
        if (isOpen) {
            setExtendDays(1); // 팝업이 열릴 때마다 기본값으로 초기화
        }
    }, [isOpen]);

    return (
        <PopupBase 
            title="슬롯 연장" 
            confirmText="연장" 
            cancelText="취소" 
            confirm={handleConfirm} 
            close={close}
            isOpen={isOpen}
        >
            <div className="modal-body">
                <div className="form-field">
                    <label className="field-lable">연장일자</label>
                    <div className="field-input">
                        <select 
                            style={{ width: '100%' }}
                            value={extendDays}
                            onChange={handleExtendDaysChange}
                        >
                            {extendOptions.map(option => (
                                <option key={option.key} value={option.value}>
                                    {option.text}
                                </option>
                            ))}
                        </select>
                    </div>
                </div>
            </div>
        </PopupBase>
    );
};

export default SlotExtendPop;
